import { Grid, FormControlLabel, Table } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const StyledTable = styled(Table)(({ theme }) => ({
  tableLayout: "fixed",
  "& .MuiTableRow-root": {
    "& .MuiTableCell-root:not(:last-of-type)": {
      borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.8)}`,
    },
  },
}));
export const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "sidebarOpen",
})<{ sidebarOpen: boolean }>(
  {
    // width: "calc(100vw - 230px)",
    borderBottom: "3px solid #f0f0f0",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  ({ sidebarOpen }) => ({
    ...(sidebarOpen && { width: "calc(100vw - 310px)" }),
  })
);

export const ContentContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const AllReportsSwitch = styled(FormControlLabel)(({ theme }) => ({
  minWidth: "150px",
  backgroundColor: theme.palette.background.paper,
  margin: "0 10px 0 20px",
  borderRadius: "20px",
}));

export const Report = styled(Grid)(({ theme }) => ({
  minHeight: 300,
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
}));
